export default function Footer() {
  return (
    <footer>
      <span>
        &copy; 2025 Kartik Naik| 
        <a href="https://github.com/KARTIKNAIK18" target="_blank" rel="noopener noreferrer">GitHub</a>
        &bull;
        <a href="https://www.linkedin.com/in/kartik-naik-194326324/" target="_blank" rel="noopener noreferrer">LinkedIn</a>
        &bull;
        <a href="mailto:kartiknaik560@gmail.com">kartiknaik560@gmail.com</a>
      </span>
      <p style={{ marginTop: '10px', fontSize: '0.9rem', opacity: 0.7 }}>
        Open to new opportunities &bull; Always learning and improving
      </p>
    </footer>
  );
}